import i18n from "../i18n";

const Issue = (app) => {
  app.post("/issues/report", async ({ req, res, locals, api, flash }) => {
    await api("issue", { method: "POST", body: req.body });
    flash(
      "success",
      i18n.t("dashboard:issue.successfullyReported")
    );
    res.refreshWith({ modal: "" }, { url: "back" });
  });
};

export default Issue;
